"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.StyledSpinner = exports.StyledLoading = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner.index"));

var _templateObject, _templateObject2, _templateObject3;

var StyledLoading = _styledComponents["default"].div.withConfig({
  displayName: "Loadingstyles__StyledLoading",
  componentId: "sc-1kln0sl-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    h-100 flex flex-column items-center justify-center pa4 flex-wrap\n    ", "\n  "])), function (_ref) {
  var fullscreen = _ref.fullscreen;
  return fullscreen ? 'fixed top-0 left-0 z-max right-0 bottom-0' : 'relative';
}));

exports.StyledLoading = StyledLoading;
var StyledSpinner = (0, _styledComponents["default"])(_Spinner["default"]).withConfig({
  displayName: "Loadingstyles__StyledSpinner",
  componentId: "sc-1kln0sl-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["w3"]))));
exports.StyledSpinner = StyledSpinner;

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "Loadingstyles__StyledText",
  componentId: "sc-1kln0sl-2"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["w-100 tc pb3"]))));

exports.StyledText = StyledText;